// Sprint 17: what a share link covers, in words (names only, never ids). Used by the Shared links page and by
// the reveal dialog after Share link on the Team report. Pure.
import { NO_PROJECT_LABEL } from '@shared/palette';
import type { ShareLink } from '@/types/admin';

export const ALL_PROJECTS_LABEL = 'All projects';

function countLabel(names: readonly string[], noun: string): string {
  return names.length === 1 ? (names[0] ?? '') : `${names.length} ${noun}`;
}

/** The project names a link covers, with No project last; empty = All projects. */
function projectNamesOf(link: Pick<ShareLink, 'scope' | 'filter'>): string[] {
  if (link.filter) return [...link.filter.projectNames, ...(link.filter.includesNoProject ? [NO_PROJECT_LABEL] : [])];
  return link.scope ? [link.scope.projectName] : [];
}

/** e.g. "All projects", "Alpha", "3 projects · 2 members", "All projects · Bob". */
export function shareLinkScopeLabel(link: Pick<ShareLink, 'scope' | 'filter'>): string {
  const projects = projectNamesOf(link);
  const members = link.filter?.memberNames ?? [];
  const parts = [projects.length === 0 ? ALL_PROJECTS_LABEL : countLabel(projects, 'projects')];
  if (members.length > 0) parts.push(countLabel(members, 'members'));
  return parts.join(' · ');
}

/** The full lists, for a tooltip; null when the label already says everything. */
export function shareLinkScopeDetail(link: Pick<ShareLink, 'scope' | 'filter'>): string | null {
  const projects = projectNamesOf(link);
  const members = link.filter?.memberNames ?? [];
  if (projects.length <= 1 && members.length <= 1) return null;
  const lines = [`Projects: ${projects.length === 0 ? ALL_PROJECTS_LABEL : projects.join(', ')}`];
  if (members.length > 0) lines.push(`Members: ${members.join(', ')}`);
  return lines.join('\n');
}
